angular.module('components.caResellerReturnOrderProductSearchMultiSelect', [])
    .component('caResellerReturnOrderProductSearchMultiSelect', {
        templateUrl: 'main/resellerorder/resellerreturnordermodify/components/resellerorderproductsearchmultiselect.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderId: '<',
            selectSameTwiceAllowed: '<',
            articlesToExclude: '<',
            disabled: '<',
            onArticlesRetrieved: '&'
        },
        controller: controller
    });

// @ngInject
function controller($q, $scope, ResellerOrdersApiService, loadSpinnerService, ToasterService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.searchResultArticles = [];
    vm.articlesToAdd = [];
    vm.result = [];
    vm.currentPage = 1;

    vm.refreshArticles = refreshArticles;
    vm.addArticles = addArticles;

    function onInit() {
        if (!vm.selectSameTwiceAllowed) {
            vm.selectSameTwiceAllowed = false;
        }

        if (!vm.pageSize) {
            vm.pageSize = 20;
        }

        $scope.$watch(function() { return (vm.company !== undefined) ?  vm.company.id : undefined; }, function() {
            vm.articlesToAdd = [];
            refreshArticles();
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }


    // Refreshes the contents of the drop-down-list of selectable articles.
    function refreshArticles(filter) {
        ResellerOrdersApiService.getProducts(vm.orderId, filter).then(function(response) {
            vm.searchResultArticles = [];
            var excludeList = [];
            if (vm.articlesToExclude !== undefined) {
                excludeList = vm.articlesToExclude.map(function(oa) {
                    return { id: oa.articleId };
                });
            }

            var products = response.data.products;

            for (var i = 0; i < products.length; i++) {
                var article = products[i];
                if (!_.find(excludeList, {'id': article.id})) {
                    vm.searchResultArticles.push(article);
                }
            }
        }, function(error) {
            ToasterService.showError(error.errors);
        });
    }

    function addArticles() {
        vm.result = [];
        var promises = [];
        loadSpinnerService.start("mainSpinner");
        _.forEach(vm.articlesToAdd, function(article) {
            var articleFetchPromise = ResellerOrdersApiService.getVariantsForProduct(vm.orderId, article.id);
            promises.push(articleFetchPromise);
        });

        $q.all(promises).then(function(responses) {
            _.forEach(responses, function(response) {
                vm.result.push(response.data);
            });
            vm.onArticlesRetrieved({articles: vm.result});
            vm.articlesToAdd = [];
            refreshArticles();
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }

}
